import React from "react";
import { Switch, Route, withRouter, Link, Navigate } from "react-router-dom";
import MainPage from "./Pages/MainPage";
import MainPageLeftDrawer from "./Pages/MainPageLeftDrawer";
import Dashboard from "./Pages/Dashboard";
import NewHeader from "./Pages/NewHeader";
import SourceManagement from "./Pages/SourceManagement";
import BundleManagement from "./Pages/BundleManagement";
import WhiteLists from "./Pages/WhiteLists";
import AutoTasks from "./Pages/AutoTasks";
import RTBManagement from "./Pages/RTBManagement";
import RTBList from "./Pages/RTBList";

function Router() {
  return (
    <div>
      <Switch>
        <Route exact path="/">
          <MainPage />
        </Route>
        <Route exact path="/Dashboard">
          <Dashboard />
        </Route>
        <Route exact path="/SourceManagement">
          <SourceManagement />
        </Route>
        <Route exact path="/Dashboard">
          <NewHeader />
        </Route>
        <Route exact path="/MainPageLeftDrawer">
          <MainPageLeftDrawer />
        </Route>
        <Route exact path="/BundleManagement">
          <BundleManagement />
        </Route>
        <Route exact path="/WhiteLists">
          <WhiteLists />
        </Route>
        <Route exact path="/AutoTasks">
          <AutoTasks />
        </Route>
        <Route exact path="/RTBManagement">
          <RTBManagement />
        </Route>
        <Route exact path="/RTBList">
          <RTBList />
        </Route>
      </Switch>
    </div>
  );
}
//MainPage
export default withRouter(Router);
